export default class MobileMenu {
  constructor() {
    // Variables
    this.$header = document.querySelector('.js-header');
    this.$hamburgers = document.querySelectorAll('.c-hamburger');
    this.$parentMenuLinks = document.querySelectorAll('.c-mobile-menu__list .menu-item.menu-item-has-children > a');
    this.$body = document.body;
    this.state = false;
    this.activeClass = 'is-active';
    this.itemHeight = document.querySelector('.c-mobile-menu__list .menu-item').offsetHeight;
    this.paddingBottom = 1.5 * 16;

    // Functions
    this.toggle = this.toggle.bind(this);

    // Events
    this.$hamburgers.forEach($hamburger => {
      $hamburger.addEventListener('click', this.toggle)
    });

    // Setup mobile menu links
    this.$parentMenuLinks.forEach(link => this.setupParentLink(link));
  }

  /**
   * @function setupParentLink
   * @param {HTMLAnchorElement} link
   */
  setupParentLink(link) {
    // determine how many sub menu items there are in each sub menu
    // then apply the min height to the submenu based on the
    // total number of items for css animations
    const subMenu = link.parentNode.querySelector('.sub-menu');
    const numSubMenuItems = subMenu.querySelectorAll('.menu-item').length;
    subMenu.dataset.minHeight = `${(numSubMenuItems * this.itemHeight) + this.paddingBottom}px`;
    subMenu.style.minHeight = '0px';

    link.addEventListener('click', this.onParentLinkClick.bind(this));
  }

  /**
   * @function Toggle
   * Toggles the mobile menu attribute;
   */
  toggle() {
    if (this.state) {
      this.state = false;
    } else {
      this.state = true;
    }

    this.$body.dataset.mobileMenu = this.state;
  }

  /**
   * @function onParentLinkClick
   * @param {Event} e
   */
  onParentLinkClick(e) {
    e.preventDefault();

    const parent = e.currentTarget.parentNode;
    const subMenu = parent.querySelector('.sub-menu');

    if (parent.classList.contains(this.activeClass)) {
      subMenu.style.minHeight = '0px';
      parent.classList.remove(this.activeClass);
    } else {
      this.$parentMenuLinks.forEach((link) => {
        // Hide sub menus in links
        const linkSubMenu = link.parentNode.querySelector('.sub-menu');
        linkSubMenu.style.minHeight = 0;

        link.parentNode.classList.remove(this.activeClass);
      });

      parent.classList.toggle(this.activeClass);
    }

    // After toggling the menu, check again if the menu is active
    // Menu is active
    if (parent.classList.contains(this.activeClass)) {
      subMenu.style.minHeight = subMenu.dataset.minHeight;
    } else {
      // Menu isn't active
      subMenu.style.minHeight = 0;
    }
  }
}
